import { ObjectUser, DashboardUsers } from '../../models';
import ReducerCreator from '../registerReducer';
import * as DASHBOARDUSERS from './dashboardUsers.constants';
import { StoreItem } from '../Store';

const r = new ReducerCreator<ObjectUser[]>()
    .register<void>(DASHBOARDUSERS.DASHBOARD_USERS_LOAD, () => {
        const newState = new StoreItem<ObjectUser[]>();
        newState.isLoading = true;
        return newState;
    })
    .register<DashboardUsers>(DASHBOARDUSERS.DASHBOARD_USERS_LOAD_SUCCESS, (state, users) => {
        const newState = new StoreItem<ObjectUser[]>();
        newState.dictionary = users;
        newState.isLoaded = true;
        return newState;
    })
    ;

export function dashboardUsersReducer(state: StoreItem<ObjectUser[]> = new StoreItem<ObjectUser[]>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
